import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
 
  btn: {
    width: "120px",
    height: "50px",

    fontSize: 13,
    padding: 8,
    transition: "background 1s, color 2s",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      color: "white",
    },
  },
}));
